interface IUniqueId {
    id:number;
    internalKey?: string;
}

interface IUniqueIdPDTO {
    id:number;
}

class UniqueId implements IUniqueId {
    id:number = 0;
}

export  {type IUniqueId , type IUniqueIdPDTO,UniqueId}